$(document).ready(function(){

let Intervaltime_google;
let counter_google = 0; 
$("#shopify-section-template--19503304966381__main > data-island > div.section-content.relative.z-10.mx-auto.max-w-site.py-section-vertical-spacing.lg\\:px-section > h2").append("<span style='display:none'>.</span>"); 

try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;

$('textarea[id^="h-captcha-response"]').attr('aria-label', 'Captcha response');
$("#shopify-section-template--20283800223981__main > data-island > div.section-content.relative.z-10.mx-auto.max-w-site.py-section-vertical-spacing.lg\\:px-section > h2").append("<span style='display:none'>.</span>");
   $('a.loox-pn-branding').attr('aria-label', 'Loox branding');
$('a.loox-pn-close').attr('aria-label', 'Close popup');
    if ( $('#goog-gt-votingInputSrcLang').length) {

$("label.adb-switch").append('<span style="display:none">.</span>');
 
$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
 $("img.add-to-cart__success").attr("alt","add to cart success");     
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}

$('img[src="https://cdn.shopify.com/s/files/1/0010/6997/3565/files/IMG_0748_480x480.jpg?v=1701466997"]').attr('alt', 'Zoe smiling and posing for a picture with sneakers in hands');
$("#shopify-section-template--19503305261293__main > data-island > div.section-content.relative.z-10.mx-auto.max-w-site.py-section-vertical-spacing.lg\\:px-section > h2").append("<span style='display:none'>.</span>")
  $('img[src="//djzodesigns.com/cdn/shop/files/gradient_logo_saturated.png?v=1748628847&width=160"]').attr('alt', 'djzodesigns Logo');



$('a[href="/cart"]').parent().css({
  'background-color': 'rgba(0,0,0,0.005)',
 
});

console.log("ready");
});
